import React, { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import { CanvasContext } from "../../../contexts/CanvasContext";

const HeaderComponent = ({ header }) => {
  const { hoveredDivision, files } = useContext(CanvasContext);
  const headerRef = useRef(null);
  const isHovered = header.id === hoveredDivision;
  const [isheaderHovered, setIsheaderHovered] = useState(false);
  const [isheaderFocused, setIsheaderFocused] = useState(false);
  const [isheaderActive, setIsheaderActive] = useState(false);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);

  const constructGradientString = () => {
    const {
      backgroundGradientImage,
      gradientDirection,
      gradientShape,
      gradientPosition,
      startColor,
      endColor,
      gradientAngle,
      patternLength,
    } = header;

    switch (backgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${gradientDirection || "to right"}, ${
          startColor || "#ff7e5f"
        }, ${endColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${gradientAngle || "45"}deg, ${
          startColor || "#606dbc"
        }, ${endColor || "#465298"} ${patternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"} ${
          patternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const constructHoverGradientString = () => {
    const {
      hoveredbackgroundGradientImage,
      hoveredgradientDirection,
      hoveredgradientShape,
      hoveredgradientPosition,
      hoveredstartColor,
      hoveredendColor,
      hoveredgradientAngle,
      hoveredpatternLength,
    } = header;

    switch (hoveredbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${hoveredgradientDirection || "to right"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${hoveredgradientShape || "circle"} at ${
          hoveredgradientPosition || "center"
        }, ${hoveredstartColor || "#ff7e5f"}, ${hoveredendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${hoveredgradientAngle || "45"}deg, ${
          hoveredstartColor || "#606dbc"
        }, ${hoveredendColor || "#465298"} ${hoveredpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          hoveredgradientShape || "circle"
        } at ${hoveredgradientPosition || "center"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"} ${hoveredpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructFocusedGradientString = () => {
    const {
      focusedbackgroundGradientImage,
      focusedgradientDirection,
      focusedgradientShape,
      focusedgradientPosition,
      focusedstartColor,
      focusedendColor,
      focusedgradientAngle,
      focusedpatternLength,
    } = header;

    switch (focusedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${focusedgradientDirection || "to right"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${focusedgradientShape || "circle"} at ${
          focusedgradientPosition || "center"
        }, ${focusedstartColor || "#ff7e5f"}, ${focusedendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${focusedgradientAngle || "45"}deg, ${
          focusedstartColor || "#606dbc"
        }, ${focusedendColor || "#465298"} ${focusedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          focusedgradientShape || "circle"
        } at ${focusedgradientPosition || "center"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"} ${focusedpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructActivatedGradientString = () => {
    const {
      activatedbackgroundGradientImage,
      activatedgradientDirection,
      activatedgradientShape,
      activatedgradientPosition,
      activatedstartColor,
      activatedendColor,
      activatedgradientAngle,
      activatedpatternLength,
    } = header;

    switch (activatedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${activatedgradientDirection || "to right"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${activatedgradientShape || "circle"} at ${
          activatedgradientPosition || "center"
        }, ${activatedstartColor || "#ff7e5f"}, ${
          activatedendColor || "#feb47b"
        })`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${
          activatedgradientAngle || "45"
        }deg, ${activatedstartColor || "#606dbc"}, ${
          activatedendColor || "#465298"
        } ${activatedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          activatedgradientShape || "circle"
        } at ${activatedgradientPosition || "center"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"} ${
          activatedpatternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const generateKeyframes = () => {
    if (!header.keyframes || header.keyframes.length === 0) return null;

    return header.keyframes.map((kf) => {
      const properties = {};
      let transform = "";

      Object.entries(kf.properties).forEach(([key, value]) => {
        // Remove 'KEY' prefix if present
        let processedKey = key.startsWith("KEY") ? key.slice(3) : key;

        // Handle transform properties
        if (
          processedKey === "scale" ||
          processedKey === "translateX" ||
          processedKey === "translateY" ||
          processedKey === "rotate" ||
          processedKey === "skewX" ||
          processedKey === "skewY"
        ) {
          if (value) {
            switch (processedKey) {
              case "scale":
                transform += `scale(${value}) `;
                break;
              case "translateX":
                transform += `translateX(${value}) `;
                break;
              case "translateY":
                transform += `translateY(${value}) `;
                break;
              case "rotate":
                transform += `rotate(${value}) `;
                break;
              case "skewX":
                transform += `skewX(${value}) `;
                break;
              case "skewY":
                transform += `skewY(${value}) `;
                break;
              default:
                break;
            }
          }
        } else {
          // Convert camelCase to kebab-case for other CSS properties
          properties[processedKey] = value;
        }
      });

      // Add transform property if it was built
      if (transform) {
        properties["transform"] = transform.trim();
      }

      return {
        offset: kf.position / 100,
        ...properties,
      };
    });
  };
  useEffect(() => {
    if (headerRef.current && header.keyframes && header.keyframes.length > 0) {
      const keyframes = generateKeyframes();
      const animation = headerRef.current.animate(keyframes, {
        duration: parseFloat(header.animationDuration) * 1000 || 1000,
        delay: parseFloat(header.animationDelay) * 1000 || 0,
        iterations:
          header.animationIterationCount === "infinite"
            ? Infinity
            : parseFloat(header.animationIterationCount) || 1,
        direction: header.animationDirection || "normal",
        fill: header.animationFillMode || "none",
        easing: header.animationTimingFunction || "linear",
      });

      return () => animation.cancel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    header.keyframes,
    header.animationDuration,
    header.animationDelay,
    header.animationIterationCount,
    header.animationDirection,
    header.animationFillMode,
    header.animationTimingFunction,
  ]);

  useEffect(() => {
    const fetchBackgroundImage = async () => {
      if (header.backgroundImage && header.backgroundImage.startsWith("./")) {
        const imageName = header.backgroundImage.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setBackgroundImageUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setBackgroundImageUrl(header.backgroundImage);
      }
    };

    fetchBackgroundImage();
  }, [header.backgroundImage, files]);

  const focusedStyles =
    isheaderFocused && header.pseudoClass === "focus"
      ? {
          width: header.focusedwidth || header.width || "100%",
          height: header.focusedheight || header.height || "auto",
          padding: header.focusedpadding || header.padding || "8px",
          paddingTop:
            header.focusedpaddingTop || header.focusedpadding || "8px",
          paddingRight:
            header.focusedpaddingRight || header.focusedpadding || "8px",
          paddingBottom:
            header.focusedpaddingBottom || header.focusedpadding || "8px",
          paddingLeft:
            header.focusedpaddingLeft || header.focusedpadding || "8px",
          margin: header.focusedmargin || header.margin || "0px",
          marginTop: header.focusedmarginTop || header.focusedmargin || "0px",
          marginRight:
            header.focusedmarginRight || header.focusedmargin || "0px",
          marginBottom:
            header.focusedmarginBottom || header.focusedmargin || "0px",
          marginLeft: header.focusedmarginLeft || header.focusedmargin || "0px",

          borderTop:
            header.focusedborderTop ||
            header.focusedborder ||
            header.border ||
            "1px solid black",
          borderRight:
            header.focusedborderRight ||
            header.focusedborder ||
            header.border ||
            "1px solid black",
          borderBottom:
            header.focusedborderBottom ||
            header.focusedborder ||
            header.border ||
            "1px solid black",
          borderLeft:
            header.focusedborderLeft ||
            header.focusedborder ||
            header.border ||
            "1px solid black",
          borderRadius:
            header.focusedborderRadius || header.borderRadius || "0",

          opacity: header.focusedOpacity || header.opacity || 1,
          color: header.focusedcolor || header.color || "#000",
          backgroundColor:
            header.focusedbackgroundColor || header.backgroundColor || "white",
          boxShadow: header.focusedboxShadow || header.boxShadow || "none",

          backgroundImage: (() => {
            if (header.focusedbackgroundImage) {
              if (header.focusedbackgroundImage.startsWith("./")) {
                const imageName = header.focusedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${header.focusedbackgroundImage})`;
            }
            if (header.backgroundImage) {
              if (header.backgroundImage.startsWith("./")) {
                const imageName = header.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${header.backgroundImage})`;
            }
            return (
              constructFocusedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            header.focusedbackgroundPosition ||
            header.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            header.focusedbackgroundSize || header.backgroundSize || "auto",
          backgroundRepeat:
            header.focusedbackgroundRepeat ||
            header.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            header.focusedbackgroundAttachment ||
            header.backgroundAttachment ||
            "scroll",

          fontFamily:
            header.focusedfontFamily || header.fontFamily || "inherit",
          fontWeight: header.focusedfontWeight || header.fontWeight || "normal",
          fontStyle: header.focusedfontStyle || header.fontStyle || "normal",
          fontVariant:
            header.focusedfontVariant || header.fontVariant || "normal",
          lineHeight: header.focusedlineHeight || header.lineHeight || "normal",
          textShadow: header.focusedtextShadow || header.textShadow || "none",
          textAlign: header.focusedtextAlign || header.textAlign || "left",
          verticalAlign:
            header.focusedverticalAlign || header.verticalAlign || "baseline",
          textDecoration:
            header.focusedtextDecoration || header.textDecoration || "none",
          textTransform:
            header.focusedtextTransform || header.textTransform || "none",
          letterSpacing:
            header.focusedletterSpacing || header.letterSpacing || "normal",
          wordSpacing:
            header.focusedwordSpacing || header.wordSpacing || "normal",
          textIndent: header.focusedtextIndent || header.textIndent || "0",
          whiteSpace: header.focusedwhiteSpace || header.whiteSpace || "normal",
          textOverflow:
            header.focusedtextOverflow || header.textOverflow || "clip",
          direction: header.focuseddirection || header.direction || "ltr",
          unicodeBidi:
            header.focusedunicodeBidi || header.unicodeBidi || "normal",
          writingMode:
            header.focusedwritingMode || header.writingMode || "horizontal-tb",

          cursor: header.focusedcursor || header.cursor || "default",
          filter: header.focusedfilter || header.filter || "none",
          backdropFilter:
            header.focusedbackdropFilter || header.backdropFilter || "none",
          mixBlendMode:
            header.focusedmixBlendMode || header.mixBlendMode || "normal",
          transform: header.focusedtransform || header.transform || "none",
          transition: header.focusedtransition || header.transition || "none",
        }
      : {};

  const hoverStyles =
    isheaderHovered && header.pseudoClass === "hover"
      ? {
          width: header.hoveredwidth || header.hovered | "100%",
          height: header.hoveredheight || header.hovered || "auto",
          padding: header.hoveredpadding || header.padding || "8px",
          paddingTop:
            header.hoveredpaddingTop || header.hoveredpadding || "8px",
          paddingRight:
            header.hoveredpaddingRight || header.hoveredpadding || "8px",
          paddingBottom:
            header.hoveredpaddingBottom || header.hoveredpadding || "8px",
          paddingLeft:
            header.hoveredpaddingLeft || header.hoveredpadding || "8px",
          margin: header.hoveredmargin || header.margin || "0px",
          marginTop: header.hoveredmarginTop || header.hoveredmargin || "0px",
          marginRight:
            header.hoveredmarginRight || header.hoveredmargin || "0px",
          marginBottom:
            header.hoveredmarginBottom || header.hoveredmargin || "0px",
          marginLeft: header.hoveredmarginLeft || header.hoveredmargin || "0px",

          borderTop:
            header.hoveredborderTop ||
            header.hoveredborder ||
            header.border ||
            "1px solid black",
          borderRight:
            header.hoveredborderRight ||
            header.hoveredborder ||
            header.border ||
            "1px solid black",
          borderBottom:
            header.hoveredborderBottom ||
            header.hoveredborder ||
            header.border ||
            "1px solid black",
          borderLeft:
            header.hoveredborderLeft ||
            header.hoveredborder ||
            header.border ||
            "1px solid black",
          borderRadius:
            header.hoveredborderRadius || header.borderRadius || "0",

          opacity: header.hoveredOpacity || header.opacity || 1,
          color: header.hoveredcolor || header.color || "#000",
          backgroundColor:
            header.hoveredbackgroundColor || header.backgroundColor || "white",
          boxShadow: header.hoveredboxShadow || header.boxShadow || "none",

          backgroundImage: (() => {
            if (header.hoveredbackgroundImage) {
              if (header.hoveredbackgroundImage.startsWith("./")) {
                const imageName = header.hoveredbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${header.hoveredbackgroundImage})`;
            }
            if (header.backgroundImage) {
              if (header.backgroundImage.startsWith("./")) {
                const imageName = header.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${header.backgroundImage})`;
            }
            return (
              constructHoverGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            header.hoveredbackgroundPosition ||
            header.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            header.hoveredbackgroundSize || header.backgroundSize || "auto",
          backgroundRepeat:
            header.hoveredbackgroundRepeat ||
            header.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            header.hoveredbackgroundAttachment ||
            header.backgroundAttachment ||
            "scroll",

          fontFamily:
            header.hoveredfontFamily || header.fontFamily || "inherit",
          fontWeight: header.hoveredfontWeight || header.fontWeight || "normal",
          fontStyle: header.hoveredfontStyle || header.fontStyle || "normal",
          fontVariant:
            header.hoveredfontVariant || header.fontVariant || "normal",
          lineHeight: header.hoveredlineHeight || header.lineHeight || "normal",
          textShadow: header.hoveredtextShadow || header.textShadow || "none",
          textAlign: header.hoveredtextAlign || header.textAlign || "left",
          verticalAlign:
            header.hoveredverticalAlign || header.verticalAlign || "baseline",
          textDecoration:
            header.hoveredtextDecoration || header.textDecoration || "none",
          textTransform:
            header.hoveredtextTransform || header.textTransform || "none",
          letterSpacing:
            header.hoveredletterSpacing || header.letterSpacing || "normal",
          wordSpacing:
            header.hoveredwordSpacing || header.wordSpacing || "normal",
          textIndent: header.hoveredtextIndent || header.textIndent || "0",
          whiteSpace: header.hoveredwhiteSpace || header.whiteSpace || "normal",
          textOverflow:
            header.hoveredtextOverflow || header.textOverflow || "clip",
          direction: header.hovereddirection || header.direction || "ltr",
          unicodeBidi:
            header.hoveredunicodeBidi || header.unicodeBidi || "normal",
          writingMode:
            header.hoveredwritingMode || header.writingMode || "horizontal-tb",

          cursor: header.hoveredcursor || header.cursor || "default",
          filter: header.hoveredfilter || header.filter || "none",
          backdropFilter:
            header.hoveredbackdropFilter || header.backdropFilter || "none",
          mixBlendMode:
            header.hoveredmixBlendMode || header.mixBlendMode || "normal",
          transform: header.hoveredtransform || header.transform || "none",
          transition: header.hoveredtransition || header.transition || "none",
        }
      : {};

  const activeStyles =
    isheaderActive && header.pseudoClass === "active"
      ? {
          width: header.activatedwidth || header.width || "100%",
          height: header.activatedheight || header.height || "auto",
          padding: header.activatedpadding || header.padding || "8px",
          paddingTop:
            header.activatedpaddingTop || header.activatedpadding || "8px",
          paddingRight:
            header.activatedpaddingRight || header.activatedpadding || "8px",
          paddingBottom:
            header.activatedpaddingBottom || header.activatedpadding || "8px",
          paddingLeft:
            header.activatedpaddingLeft || header.activatedpadding || "8px",
          margin: header.activatedmargin || header.margin || "0px",
          marginTop:
            header.activatedmarginTop || header.activatedmargin || "0px",
          marginRight:
            header.activatedmarginRight || header.activatedmargin || "0px",
          marginBottom:
            header.activatedmarginBottom || header.activatedmargin || "0px",
          marginLeft:
            header.activatedmarginLeft || header.activatedmargin || "0px",

          borderTop:
            header.activatedborderTop ||
            header.activatedborder ||
            header.border ||
            "1px solid black",
          borderRight:
            header.activatedborderRight ||
            header.activatedborder ||
            header.border ||
            "1px solid black",
          borderBottom:
            header.activatedborderBottom ||
            header.activatedborder ||
            header.border ||
            "1px solid black",
          borderLeft:
            header.activatedborderLeft ||
            header.activatedborder ||
            header.border ||
            "1px solid black",
          borderRadius:
            header.activatedborderRadius || header.borderRadius || "0",

          opacity: header.activatedOpacity || header.opacity || 1,
          color: header.activatedcolor || header.color || "#000",
          backgroundColor:
            header.activatedbackgroundColor ||
            header.backgroundColor ||
            "white",
          boxShadow: header.activatedboxShadow || header.boxShadow || "none",

          backgroundImage: (() => {
            if (header.activatedbackgroundImage) {
              if (header.activatedbackgroundImage.startsWith("./")) {
                const imageName = header.activatedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${header.activatedbackgroundImage})`;
            }
            if (header.backgroundImage) {
              if (header.backgroundImage.startsWith("./")) {
                const imageName = header.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${header.backgroundImage})`;
            }
            return (
              constructActivatedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            header.activatedbackgroundPosition ||
            header.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            header.activatedbackgroundSize || header.backgroundSize || "auto",
          backgroundRepeat:
            header.activatedbackgroundRepeat ||
            header.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            header.activatedbackgroundAttachment ||
            header.backgroundAttachment ||
            "scroll",

          fontFamily:
            header.activatedfontFamily || header.fontFamily || "inherit",
          fontWeight:
            header.activatedfontWeight || header.fontWeight || "normal",
          fontStyle: header.activatedfontStyle || header.fontStyle || "normal",
          fontVariant:
            header.activatedfontVariant || header.fontVariant || "normal",
          lineHeight:
            header.activatedlineHeight || header.lineHeight || "normal",
          textShadow: header.activatedtextShadow || header.textShadow || "none",
          textAlign: header.activatedtextAlign || header.textAlign || "left",
          verticalAlign:
            header.activatedverticalAlign || header.verticalAlign || "baseline",
          textDecoration:
            header.activatedtextDecoration || header.textDecoration || "none",
          textTransform:
            header.activatedtextTransform || header.textTransform || "none",
          letterSpacing:
            header.activatedletterSpacing || header.letterSpacing || "normal",
          wordSpacing:
            header.activatedwordSpacing || header.wordSpacing || "normal",
          textIndent: header.activatedtextIndent || header.textIndent || "0",
          whiteSpace:
            header.activatedwhiteSpace || header.whiteSpace || "normal",
          textOverflow:
            header.activatedtextOverflow || header.textOverflow || "clip",
          direction: header.activateddirection || header.direction || "ltr",
          unicodeBidi:
            header.activatedunicodeBidi || header.unicodeBidi || "normal",
          writingMode:
            header.activatedwritingMode ||
            header.writingMode ||
            "horizontal-tb",

          cursor: header.activatedcursor || header.cursor || "default",
          filter: header.activatedfilter || header.filter || "none",
          backdropFilter:
            header.activatedbackdropFilter || header.backdropFilter || "none",
          mixBlendMode:
            header.activatedmixBlendMode || header.mixBlendMode || "normal",
          transform: header.activatedtransform || header.transform || "none",
          transition: header.activatedtransition || header.transition || "none",
        }
      : {};

  const headerStyle = {
    width: header.width || "100%",
    height: header.height || "50px",
    margin: header.margin || "0",
    marginTop: header.marginTop || header.margin || "0",
    marginRight: header.marginRight || header.margin || "0",
    marginBottom: header.marginBottom || header.margin || "0",
    marginLeft: header.marginLeft || header.margin || "0",
    padding: header.padding || "0",
    paddingTop: header.paddingTop || header.padding || "0",
    paddingRight: header.paddingRight || header.padding || "0",
    paddingBottom: header.paddingBottom || header.padding || "0",
    paddingLeft: header.paddingLeft || header.padding || "0",

    fontFamily: header.fontFamily || "inherit",
    fontWeight: header.fontWeight || "inherit",
    fontStyle: header.fontStyle || "inherit",
    fontVariant: header.fontVariant || "inherit",
    lineHeight: header.lineHeight || "inherit",
    textShadow: header.textShadow || "none",
    textAlign: header.textAlign || "inherit",
    verticalAlign: header.verticalAlign || "baseline",
    textDecoration: header.textDecoration || "inherit",
    textTransform: header.textTransform || "inherit",
    letterSpacing: header.letterSpacing || "inherit",
    wordSpacing: header.wordSpacing || "inherit",
    textIndent: header.textIndent || "inherit",
    whiteSpace: header.whiteSpace || "inherit",
    textOverflow: header.textOverflow || "clip",
    direction: header.direction || "ltr",
    unicodeBidi: header.unicodeBidi || "normal",
    writingMode: header.writingMode || "inherit",

    color: header.color || "inherit",
    backgroundColor: header.backgroundColor || "transparent",
    opacity: header.opacity || "1",

    borderTop: isHovered
      ? "1px dashed #555555 "
      : header.borderTop || header.border || "none",
    borderRight: isHovered
      ? "1px dashed #555555 "
      : header.borderRight || header.border || "none",
    borderBottom: isHovered
      ? "1px dashed #555555 "
      : header.borderBottom || header.border || "none",
    borderLeft: isHovered
      ? "1px dashed #555555 "
      : header.borderLeft || header.border || "none",
    borderRadius: header.borderRadius || "0",

    backgroundImage: backgroundImageUrl
      ? `url(${backgroundImageUrl})`
      : constructGradientString(),
    backgroundRepeat: header.backgroundRepeat || "repeat",
    backgroundPosition: header.backgroundPosition || "0% 0%",
    backgroundSize: header.backgroundSize || "auto",
    backgroundAttachment: header.backgroundAttachment || "scroll",
    backgroundBlendMode: header.backgroundBlendMode || "normal",
    position: header.position || "relative",
    top: header.top || "auto",
    right: header.right || "auto",
    bottom: header.bottom || "auto",
    left: header.left || "auto",
    zIndex: header.zIndex || "auto",
    boxShadow: header.boxShadow || "none",
    overflow: header.overflow || "visible",

    lineBreak: header.lineBreak || "auto",
    hyphens: header.hyphens || "none",
    wordBreak: header.wordBreak || "normal",
    wordWrap: header.wordWrap || "normal",
    tabSize: header.tabSize || "8",
    overflowWrap: header.overflowWrap || "normal",
    textAlignLast: header.textAlignLast || "auto",
    textJustify: header.textJustify || "auto",
    colorAdjust: header.colorAdjust || "economy",

    scale: isHovered ? "1.01" : "1",

    ...activeStyles,
    ...hoverStyles,
    ...focusedStyles,
  };

  const HeaderTag = `h${header.level || 1}`;

  const createMarkup = () => {
    return { __html: header.text || "Header" };
  };

  return (
    <HeaderTag
      style={headerStyle}
      dangerouslySetInnerHTML={createMarkup()}
      onMouseEnter={() => setIsheaderHovered(true)}
      onMouseLeave={() => setIsheaderHovered(false)}
      onFocus={() => setIsheaderFocused(true)}
      onBlur={() => setIsheaderFocused(false)}
      onMouseDown={() => setIsheaderActive(true)}
      onMouseUp={() => setIsheaderActive(false)}
      tabIndex="0"
      ref={headerRef}
    />
  );
};

export default HeaderComponent;
